export {default as dispatch} from "./src/dispatch";



//////////////////
// WEBPACK FOOTER
// ./~/d3-dispatch/index.js
// module id = 149
// module chunks = 2